export default __webpack_public_path__ + "static/media/pe.b8e62fe3.svg";